import axios from "axios";

const baserUrl =
  "https://cors-anywhere.herokuapp.com/http://18.211.207.245:3000";
const env = {
  prod: process.env.REACT_APP_PAYMENT_PROD_API,
  dev: process.env.REACT_APP_PAYMENT_DEV_API
};
const orgEnv = {
  prod: process.env.REACT_APP_BASEURL_PROD_API,
  dev: process.env.REACT_APP_BASEURL_DEV_API
};

let currentEnv;
if (
  window.location.host.includes("amazon") ||
  window.location.host.includes("localhost") ||
  window.location.host.includes("shapla")

) {
  currentEnv = "dev";
} else {
  currentEnv = "prod";
}
const orgBaseUrl = process.env.REACT_APP_PROJECT_ENV === 'prod' ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV;

export function GetContacts(token, id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${orgBaseUrl}/contact?orgId=${id}`, {
        headers: {
          token
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function DeleteContact(token, id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${orgBaseUrl}/dc-contact-us/${id}`, {
        headers: {
          token
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function UpdateContact(token, id, data) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${orgBaseUrl}/dc-contact-us/${id}`, data , {
        headers: {
          token
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}